import create from '@/utils/create';
import viewList from '../page/view.vue'


const componentsContext = require.context('../components', true, /index.vue$/);

const components = []

componentsContext.keys().forEach(key => {
  const componentConfig = componentsContext(key);
  const component = create(componentConfig.default || componentConfig);
  components.push(component)
});

components.push(viewList)

// console.log(components,'components')
const kk = {}
// kk['viewList'] = viewList
// 定义 install 方法，接收 Vue 作为参数。如果使用 use 注册插件，则所有的组件都将被注册
const install = function (Vue) {
  // 判断是否安装
  if (install.installed) return
  // 遍历注册全局组件
  components.map(component => {
    kk[component.name] = component;
  
    Vue.component(component.name, component)
  })
}
 
// 判断是否是直接引入文件
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
// console.log(kk)
export default {
  // 导出的对象必须具有 install，才能被 Vue.use() 方法安装
  install,
  // 以下是具体的组件列表
  ...kk
}